window.addEventListener("DOMContentLoaded", function () {
  let modalButtons = document.querySelectorAll("[data-modal-trigger]");

  // prevent modal buttons from adding to cart
  for (let i = 0; i < modalButtons.length; i++) {
    modalButtons[i].addEventListener("click", function (e) {
      e.preventDefault();
    });
  }

  if (modalButtons.length > 0) {
    MicroModal.init({
      // onShow: (modal) => console.info(`${modal.id} is shown`),
      // onClose: (modal) => console.info(`${modal.id} is hidden`),
      openTrigger: "data-modal-trigger", // [3]
      openClass: "is-open", // [5]
      disableScroll: false, // [6]
      disableFocus: false, // [7]
      awaitOpenAnimation: true, // [8]
      awaitCloseAnimation: true, // [9]
      debugMode: false, // [10]
      onClose: function (modal, element, event) {
        event.preventDefault();
        event.stopPropagation();
      },
    });
  }
});
